export const SYNC = 'SYNC';
export const SET_PROPERTIES_DATA = "SET_PROPERTIES_DATA"
export const FETCH_AGENT = 'FETCH_AGENT';
export const FETCH_SCENARIOS = 'FETCH_SCENARIOS';
export const SET_SELCTED_CONVERSATION = 'SET_SELCTED_CONVERSATION';
export const SET_TEAM_DETAILS = 'SET_TEAM_DETAILS';
export const SET_ACTIVE_AGENTS = 'SET_ACTIVE_AGENTS';
export const SET_USER_PROPERTIES = 'SET_USER_PROPERTIES';
export const SET_AGENT_PROPERTIES = 'SET_AGENT_PROPERTIES';
export const SET_FAQ_STATUS = 'SET_FAQ_STATUS';
export const SET_ORDERS ='SET_ORDERS';
export const SET_PERSON_ID = 'SET_PERSON_ID';
export const SET_ORDER_STATUS = 'SET_ORDER_STATUS';
export const SET_CUSTOMER_PROPERTIES = 'SET_CUSTOMER_PROPERTIES';
export const SET_SCENARIO_PRECHAT_PROPERTIES = 'SET_SCENARIO_PRECHAT_PROPERTIES';
export const SET_ERRORS = 'SET_ERRORS'
export const SET_LOADING = 'SET_LOADING'
export const SET_ORDER_SHIPMENT_DETAILS = 'SET_ORDER_SHIPMENT_DETAILS'
export const RESET_ORDERS_DATA="RESET_ORDERS_DATA";